// Vibe color mapping — activity categories to colors

const CATEGORY_COLORS = {
  culture: '#1A73E8',
  cultural: '#1A73E8',
  heritage: '#1A73E8',
  museum: '#1A73E8',
  temple: '#1A73E8',
  history: '#1A73E8',
  nature: '#16A34A',
  outdoor: '#16A34A',
  hiking: '#16A34A',
  park: '#16A34A',
  wildlife: '#16A34A',
  food: '#F59E0B',
  culinary: '#F59E0B',
  dining: '#F59E0B',
  restaurant: '#F59E0B',
  cafe: '#F59E0B',
  adventure: '#EA580C',
  sport: '#EA580C',
  diving: '#EA580C',
  trekking: '#EA580C',
  relaxation: '#14B8A6',
  spa: '#14B8A6',
  beach: '#14B8A6',
  wellness: '#14B8A6',
  shopping: '#8B5CF6',
  market: '#8B5CF6',
  nightlife: '#EC4899',
  bar: '#EC4899',
  entertainment: '#EC4899',
};

const DEFAULT_COLOR = '#6B7280';

/**
 * Determine the dominant vibe color for a set of activities.
 * Counts category keywords in activity types/names and returns the most common color.
 * @param {Array} activities — array of activity objects with `type`, `category`, or `name` fields
 * @returns {string} — hex color
 */
export function computeDayVibe(activities) {
  if (!activities?.length) return DEFAULT_COLOR;

  const colorCounts = {};

  activities.forEach((activity) => {
    const text = [activity.type, activity.category, activity.name]
      .filter(Boolean)
      .join(' ')
      .toLowerCase();

    for (const [keyword, color] of Object.entries(CATEGORY_COLORS)) {
      if (text.includes(keyword)) {
        colorCounts[color] = (colorCounts[color] || 0) + 1;
        break; // one match per activity
      }
    }
  });

  if (Object.keys(colorCounts).length === 0) return DEFAULT_COLOR;

  return Object.entries(colorCounts).sort((a, b) => b[1] - a[1])[0][0];
}

export { CATEGORY_COLORS, DEFAULT_COLOR };
